import React, { useEffect, useState } from 'react';
import { MDBTable, MDBTableBody } from 'mdbreact';
import { useLanguage } from '../../context/language';
import { getStrLang } from '../Translate';
import { getDeposit,getNewAmount } from '../../api/fastcoinService';
import { useHistory, useLocation } from 'react-router-dom';
import Loading from '../../assets/loading.gif';
import { countryConfig,defaultConfig } from '../../util/countryConfig';
import { useInstalment } from '../../context/InstalmentContext'; 

const methodForNewRate = [
    "cash", "card", "crypto",
    "GApay", "CCS","CCX", "monnet_bank_transfer", "monnet_cash", "monnet_dc", "monnet_cc","monnet_wallet", "SPEI", "picpay", "sepa", "CCP", "CCR","CCB",
    "pagoefectivo_ecu_payment", "payphone_payment", "pagoefectivo_payment", "prometeo_payment", "niubiz_payment", "webpay_payment",
    "etpay_payment", "mach_payment", "mercadopagoqr_payment", "deuna_payment", "redactiva_payment", "bemovil_payment", "broadnet_payment",
    "marketpaymentqr_payment", "PayWithYourBank", "servifacil_payment", "pay_cash", "upi", "phone_pe", "pay_tm", "g_pay", "qr_code",
    "momopay", "atm", "payfix", "papara", "debit_card", "virtual_account", "wallets", "mobile_money", "pay_id", "bank_transfer", "rapipago",
    "pagofacil", "GACC", "TrueMoney", "ofa_qr_code", "OFA_UPI", "GrabPay", "QRPHP", "MAYA_Original", "Gcash_Original", "Maya", "Gcash",
    "QRIS", "VABCA", "Duitnow", "Zalo", "P2C", "Viettelpay", "MOMO", "OB", "ofapay_virtual_account", "ECNY", "DinTalk", "P2P_Manual", "P2P",
    "Alipay2alipay", "USDtPIX", "treviso", "stp", "red_pagos", "provincia_net", "prometeo", "newpay", "cobre", "b89",
    "webpay_payment_payku",
    "khipu_payku",
    "multicaja_efectivo_payku",
    "etpay_payment_payku",
    "onepay_payku",
    "pago46_payku",
    "cleo_payku",
    "hites_payku",
    "mach_payment_payku",
    "chek_payku",
    "cybersource_payku",
    "transaccion_completa_payku",
    "servifacil_payment_payku",
    "vepuy_payku",
    "klap_payku",
    "fintoc_payku",
    "safety_payku",
    "CCA","simplypay","cobre","spei_cobre","sauripay"
]
//Funções e constantes para formatar os valores monetários
const numUSD = new Intl.NumberFormat(
    "en-US"
)

function numOther(digits) {
    return new Intl.NumberFormat("en-US", {
        style: 'decimal',
        minimumFractionDigits: digits,
        maximumFractionDigits: digits,
    })
}


let crnt_method=""

const ReturnInfo = (props) => {
    //utilizando o contexto
    const { lang, setOrderFromDeposit } = useLanguage();

    //Acessando informações da rota
    const history = useHistory();
    const location = useLocation();
    const [infoDepositValue, setInfoDepositValue] = useState("info-deposit-value");
    const { instalment ,setInstalmentFee,setFeePercentage} = useInstalment();

    //hooks
    const [infoApi, setInfoApi] = useState({
        ordem: <img src={Loading} alt={"loading"} width="15px" height="15px" />,
        //dt_criacao: <img src={Loading} alt={"loading"} width="15px" height="15px" />,
        //dt_atualizacao: <img src={Loading} alt={"loading"} width="15px" height="15px" />,
        status: <img src={Loading} alt={"loading"} width="15px" height="15px" />,
        //cliente: <img src={Loading} alt={"loading"} width="15px" height="15px" />,
        //pais: <img src={Loading} alt={"loading"} width="15px" height="15px" />,
        amount: <img src={Loading} alt={"loading"} width="15px" height="15px" />,
        conv_amount: <img src={Loading} alt={"loading"} width="15px" height="15px" />,
        rate: <img src={Loading} alt={"loading"} width="15px" height="15px" />,
        custo: <img src={Loading} alt={"loading"} width="15px" height="15px" />
    });

    useEffect(()=>{
        crnt_method=props.currentMethod
        if(props.currentMethod){
            if(methodForNewRate.find((m)=>m===props.currentMethod)){
                setInfoApi({...infoApi,rate:<img src={Loading} alt={"loading"} width="15px" height="15px" />,custo:<img src={Loading} alt={"loading"} width="15px" height="15px" />,conv_amount:<img src={Loading} alt={"loading"} width="15px" height="15px" />})
                let order_no = sessionStorage.getItem("order_no");

                getNewAmount(order_no,props.currentMethod,instalment).then((result)=>{
                    const { prefix, formatter } = countryConfig[result.country] || defaultConfig;

                    let amountConverted = `${prefix}${formatter.format(result.converted_amount)}`;
                    let rateConv = `${prefix}${formatter.format(result.rate_used)}`;
                  

                    if(methodForNewRate.find((m)=>m===props.currentMethod)){
                        if(crnt_method==="sepa"){
                            setInfoApi({...infoApi,custo:"€ "+numOther(2).format(0.000),rate:"€ " + numOther(2).format(result.rate_used),conv_amount:"€ " + numOther(2).format(result.converted_amount) })
                        }else if(crnt_method==="CCA"){
                            let custo = `${prefix}${formatter.format(result.instalment_fee || 0)}`;
                            
                            setInfoApi({...infoApi,custo:custo,rate:rateConv,conv_amount:amountConverted})
                            setInstalmentFee(result?.instalment_fee)
                            setFeePercentage(result?.fee_percentage)
                        }else{
                            setInfoApi({...infoApi,custo:sessionStorage.getItem("custo"),rate:rateConv,conv_amount:amountConverted})
                        }
                    }else{
                        setInfoApi({...infoApi,custo:sessionStorage.getItem("custo"),rate:sessionStorage.getItem("rate"),conv_amount:sessionStorage.getItem("conv_amount")})
                    }
                });
            }else{
                setInfoApi({...infoApi,custo:sessionStorage.getItem("custo"),rate:sessionStorage.getItem("rate"),conv_amount:sessionStorage.getItem("conv_amount")})
            }
        }
    },[props.currentMethod,instalment])

    let data_return =  infoApi.usd && infoApi.country!=="OT" ? {        
        columns: [
            {
                field: 'campo',
                sort: 'asc',
            },
            {
                field: 'valor',
                sort: 'asc'
            }
        ],
        rows: [
            {
                'campo': getStrLang(lang.nameLang, "ordem_num"),
                'valor': infoApi.ordem
            },        
            {
                'campo': getStrLang(lang.nameLang, "status_"),
                'valor': getStrLang(lang.nameLang, infoApi.status)
            },   
            {
                'campo': getStrLang(lang.nameLang, "value_table"),
                'valor': infoApi.amount
            },
            {
                'campo': getStrLang(lang.nameLang, "value_convert_table"),
                'valor': infoApi.conv_amount
            },
            {
                'campo': getStrLang(lang.nameLang, "tx_cambio_table"),
                'valor': infoApi.rate
            },
            {
                'campo': getStrLang(lang.nameLang, "custo"),
                'valor': infoApi.custo
            }
        ]     
    }:
    {
        columns: [
            {
                field: 'campo',
                sort: 'asc',
            },
            {
                field: 'valor',
                sort: 'asc'
            }
        ],
        rows: [
            {
                'campo': getStrLang(lang.nameLang, "ordem_num"),
                'valor': infoApi.ordem
            },    
            {
                'campo': getStrLang(lang.nameLang, "status_"),
                'valor': getStrLang(lang.nameLang, infoApi.status)
            },
            {
                'campo': getStrLang(lang.nameLang, "value_table"),
                'valor': infoApi.conv_amount
            },          
            {
                'campo': getStrLang(lang.nameLang, "custo"),
                'valor': infoApi.custo
            }
        ]        
    };

    //Essa função busca e atualiza as informações da ordem para exibir na tela de /deposit
    useEffect(() => {
        sessionStorage.setItem("try_request", "1");
        
        const getDepositInfo = async () => {
            //Pegando valores dos parametros na URL
            let param = sessionStorage.getItem("order_no");
            //console.log(param);
            if (param !== null) {
                //Aqui é chamado o back-end para requisitar as informações do depósito
                let result = await getDeposit(param);
                if (result !== undefined) {

                    //Validando se é uma ordem diferente, pois se for a mesma ordem ele não precisa limpar valores anteriores
                    if (sessionStorage.getItem("order_no") !== result.order_no.toString()) {
                        sessionStorage.clear();
                        sessionStorage.clear();
                    }

                    //Montagem de todas as informações de depósito que aparecerão na tabela lateral vindas da API da fastcoin
                    let amount;
                    let amountConverted;
                    let rateConv;
                    let custo;                    

                    amount = "$ " + numUSD.format(result.usd_amount)
                    
                    const { prefix, formatter } = countryConfig[result.country] || defaultConfig;

                    // Format values
                    amountConverted = `${prefix}${formatter.format(result.converted_amount)}`;
                    rateConv = `${prefix}${formatter.format(result.rate_used)}`;
                    custo = `${prefix}${formatter.format(0.000)}`;


                    sessionStorage.setItem("conv_amount", amountConverted);
                    sessionStorage.setItem("rate", rateConv)
                    sessionStorage.setItem("custo", custo)

                    //Criando um status da ordem amigável para o usuário
                    sessionStorage.setItem("order_no", result.order_no);
                    sessionStorage.setItem("pix_time_limit", result.pix_time_limit);
                    sessionStorage.setItem("full_Name", result.full_Name);
                    sessionStorage.setItem("order_amount", result.converted_amount.toFixed(2));
                    sessionStorage.setItem("date_order", result.date);
                    sessionStorage.setItem("url",(result.url));
                    sessionStorage.setItem("url_confirm_pay", (result.redirect_url ? result.redirect_url : result.url_confirm_pay));
                    if (result.cpf_no !== undefined) {
                        sessionStorage.setItem("documento_cliente", result.cpf_no);
                    }
                    if (sessionStorage.getItem("email") === undefined || sessionStorage.getItem("email") === null)
                        sessionStorage.setItem("email", result.email);
                    setOrderFromDeposit(result.country.toLowerCase());
                    setInfoApi({
                        ordem: result.order_no,
                        //dt_criacao: formatDataAPI(result.createdAt),
                        //dt_atualizacao: formatDataAPI(result.updatedAt),
                        status: result.status,
                        //cliente: result.client_name,
                        //pais: result.country,
                        amount: amount,
                        conv_amount: amountConverted,
                        rate: rateConv,
                        custo: custo, 
                        usd:result.is_usd,
                        country:result?.country
                    })
                } else {
                    if (sessionStorage.getItem("try_request") === "1") {
                        sessionStorage.setItem("try_request", "2");
                        setTimeout(getDepositInfo, 5000);
                    } else {
                        setInfoApi({
                            ordem: "not found",
                            status: "-",
                            amount: "-",
                            conv_amount: "-",
                            rate: "-",
                            custo: "-"       ,
                            country:""                    
                        });
                        let country = sessionStorage.getItem("country");
                        let broker = sessionStorage.getItem("broker");
                        history.push("/404", { country: country, broker: broker, order_no: param + " - nf", from: history.location.pathname })
                    }
                }
            }
        };
        let country = sessionStorage.getItem("country");
        if(country?.toLowerCase()==='co'){
            setInfoDepositValue("info-deposit-value-co");
        }; 
        getDepositInfo();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    return (
        <div className="info-deposit">
            <div className="info-deposit-title">
                {sessionStorage.getItem("client_name") && sessionStorage.getItem("client_name") !=="." ? <>
                    <h4>{getStrLang(lang.nameLang, "info_deposit") +sessionStorage.getItem("client_name")}</h4>
                    <hr />
                </>:<div style={{marginTop:'5px'}}></div>}
                <MDBTable striped>
                    <MDBTableBody rows={data_return.rows} />
                </MDBTable>
                <hr />
            </div>
            <div className={infoDepositValue}>
                <h3 className="green">{getStrLang(lang.nameLang, "total_value")}</h3>
                <h3 className="value-info">{infoApi.conv_amount}</h3>
            </div>
        </div>
    );
};

export default ReturnInfo;